// Mesai Yönetimi - Yardımcı Fonksiyonlar

import { roleTitles } from './mesaiConstants';

/**
 * Kullanıcının oturum bilgilerini getirir
 */
export const getCurrentUser = () => {
  const auth = JSON.parse(localStorage.getItem('parkBakimAuth') || '{}');
  return {
    id: auth.personnelId,
    name: auth.personnelName,
    role: auth.role
  };
};

/**
 * Rol başlığını döndürür
 */
export const getRoleTitle = (role) => {
  return roleTitles[role] || role;
};

/**
 * Tarihleri kronolojik sıralar
 */
export const sortDates = (dates) => {
  if (!dates || !Array.isArray(dates)) return [];
  return [...dates].sort((a, b) => new Date(a) - new Date(b));
};

/**
 * Kullanıcının ankete cevap verip vermediğini kontrol eder
 */
export const hasUserResponded = (survey, personnelId) => {
  if (!survey || !personnelId) return false;
  return survey.responded_by?.includes(personnelId) || 
         survey.declined_by?.some(d => d.personnel_id === personnelId);
};

/**
 * Anket oluşturucusunun üst düzey yönetici olup olmadığını kontrol eder
 */
export const isCreatorHighLevel = (creatorRole) => {
  return ['mudur', 'mudur_yardimcisi'].includes(creatorRole);
};

/**
 * Görüntüleyenin alt düzey yönetici olup olmadığını kontrol eder
 */
export const isViewerLowerLevel = (viewerRole) => {
  return ['bolge_muhendisi', 'formen'].includes(viewerRole);
};

/**
 * Önizleme modunu kontrol eder
 * Müdür/Müdür Yrd. oluşturduysa ve BM/Formen görüntülüyorsa true döner
 */
export const checkPreviewMode = (creatorRole, viewerRole) => {
  return isCreatorHighLevel(creatorRole) && isViewerLowerLevel(viewerRole);
};

/**
 * Plan durumuna göre renk ve etiket döndürür
 */
export const getPlanStatusInfo = (status) => {
  const statusMap = {
    taslak: { color: 'bg-gray-500', label: 'Taslak' },
    beklemede: { color: 'bg-yellow-500', label: 'Onay Bekliyor' },
    onaylandi: { color: 'bg-green-500', label: 'Onaylandı' },
    reddedildi: { color: 'bg-red-500', label: 'Reddedildi' },
    iptal: { color: 'bg-gray-400', label: 'İptal Edildi' }
  };
  return statusMap[status] || { color: 'bg-gray-500', label: status };
};

// NOT: filterPersonnelByHierarchy KALDIRILDI. Hiçbir yerden çağrılmıyordu ve
// gövdesinde tanımsız isimler (isMudur, isMudurYardimcisi, isBolgeMuhendisi,
// isFormen) kullanıyordu — çağrılsaydı ReferenceError verecekti. Rol kapsamı
// bugün sunucu tarafında ve useRoleFlags ile çözülüyor.


/**
 * Parkları hiyerarşik olarak filtreler
 */
export const filterParksByHierarchy = (parks, userRole, myRegionIds) => {
  if (!parks) return [];
  
  // Üst amirler tüm parkları görebilir
  if (['mudur', 'mudur_yardimcisi', 'bolge_muhendisi'].includes(userRole)) {
    return parks;
  }
  
  // Formen sadece kendi bölgesindeki parkları görebilir
  if (myRegionIds && myRegionIds.length > 0) {
    return parks.filter(park => myRegionIds.includes(park.region_id));
  }
  
  return parks;
};
